<template>
  <div class="liu pos-manage">
    <mt-header fixed :title="title" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <!-- 开通微信支付 -->
    <div :style="customScrollHeight" id="wxImage" v-if="payType == 1">
      <img ref="qrImg" :src="qrCode" :style="dynamicQrcodePositionStyle" />
      <div :style="namePositionStyle" v-if="serviceProviderName">
        {{ serviceProviderName }}
      </div>
    </div>
    <!-- 开通支付宝支付 -->
    <div :style="aliCustomScrollHeight" id="aliPayImage" v-if="payType == 2">
      <img ref="qrImg" :src="noImg" :style="aliQrcodePositionStyle" v-if="noImg" />
      <!-- 支付宝会有两种图片 只返回二维码图片则拼接显示服务商名 -->
      <div :style="namePositionStyle" v-if="serviceProviderNameShow">
        {{ serviceProviderName }}
      </div>
    </div>
    <!-- 商户号 -->
    <div :style="merchantIdStyle" v-if="wechatMerchantId">
      <span v-clipboard:copy="wechatMerchantId" v-clipboard:success="onWordCopySuccess" v-clipboard:error="onWordCopyError">{{ payType == 1 ? "微信" : "支付宝" }}商户号：{{ wechatMerchantId }}</span>
    </div>
    <!-- 按钮 -->
    <div :style="detailTextStyle" v-if="hasQrCode">
      截屏保存图片至相册，打开{{ this.payType==1?"微信":"支付宝" }}，点击扫一扫，选择相册，选择此图片扫描，进入小程序后按页面指引提交信息，并进行主体身份验证。
    </div>
  </div>
</template>
<script>
import { GetWeChatMerchantMsg, GetAliPayMerchantMsg } from '@/api/customer';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'H5PosManageOpenPayPage',
  data() {
    return {
      title: '',
      typeStr: '',
      qrCode: '',
      wechatMerchantId: '',
      payType: 1, // 1微信 2支付宝
      serviceProviderName: '',
      errorMsg: '',
      screenWidth: window.screen.width,
      div1BgImgW: 335,
      div1BgImgH: 370,
      div1BgImgPath: require('@/assets/wechatpay_success@3x.png'),
      div2BgImgPath: require('@/assets/alipay_success@3x.png'),
      noImg: '', // 支付宝占位图
      hasQrCode: '',
      serviceProviderNameShow: false,
    };
  },
  mounted() {
    // 设置微信或支付宝的页面相关信息
    if (this.$route.query.payType === 'wx') {
      this.payType = 1;
      this.typeStr = '微信';
      this.title = '开通微信支付';
      this.div1BgImgPath = require('@/assets/wechatpay_success@3x.png');
      this.getWeChatMerchantMsg(this.$route.query.id);
    } else {
      this.payType = 2;
      this.typeStr = '支付宝';
      this.title = '开通支付宝支付';
      this.div2BgImgPath = require('@/assets/alipay_success@3x.png');
      this.getAliPayMerchantMsg(this.$route.query.id);
    }
  },
  computed: {
    customScrollHeight() {
      // alert(window.screen.width);
      const bgWidth = this.div1BgImgW * (this.screenWidth / 375);
      const bgHeight = this.div1BgImgH * (this.screenWidth / 375);
      return `width:${bgWidth}px;height:${bgHeight}px;background-image:url(${this.div1BgImgPath});background-repeat:no-repeat;background-size:100% 100%;position:relative;top:70px;margin:0 auto;`;
    },
    aliCustomScrollHeight() {
      const bgWidth = 335 * (this.screenWidth / 375);
      const bgHeight = 442.5 * (this.screenWidth / 375);
      return `width:${bgWidth}px;height:${bgHeight}px;background-image:url(${this.div2BgImgPath});background-repeat:no-repeat;background-size:100% 100%;position:relative;top:70px;margin:0 auto;`;
    },
    dynamicQrcodePositionStyle() {
      let top = 0;
      let left = 0;
      switch (this.screenWidth) {
        case 320:
          top = 98.56;
          left = 75.1;
          break;
        case 360:
          top = 111;
          left = 84.48;
          break;
        case 375:
          top = 115.5;
          left = 88;
          break;
        case 411:
        case 412:
          top = 128.5;
          left = 97;
          break;
        case 414:
          top = 130;
          left = 98;
          break;
        case 480:
          top = 147.8;
          left = 126.6;
          break;
        default:
          top = 115.5 * (this.screenWidth / 375);
          left = 88 * (this.screenWidth / 375);
      }
      const CodeWidth = 159.5 * (this.screenWidth / 375);
      return `position:absolute;top:${top}px;left:${left}px;width:${CodeWidth}px;height:${CodeWidth}px`;
    },
    aliQrcodePositionStyle() {
      const top = 128.5 * (this.screenWidth / 375);
      const left = 61 * (this.screenWidth / 375);
      const CodeWidth = 212 * (this.screenWidth / 375);
      return `position:absolute;top:${top}px;left:${left}px;width:${CodeWidth}px;height:${CodeWidth}px`;
    },
    namePositionStyle() {
      let top = 0;
      let fontSize = 28 * (this.screenWidth / 375);
      if (this.payType === 1) {
        top = 280 * (this.screenWidth / 375);
      } else {
        top = 376 * (this.screenWidth / 375);
      }
      if (this.serviceProviderName.length > 11) {
        switch (this.serviceProviderName.length) {
          case 12:
            fontSize = fontSize - 1;
            break;
          case 13:
            fontSize = fontSize - 3;
            break;
          case 14:
            fontSize = fontSize - 5;
            break;
          case 15:
            fontSize = fontSize - 7;
            break;
          case 16:
            fontSize = fontSize - 9;
            break;
          case 17:
            fontSize = fontSize - 10;
            break;
          case 18:
            fontSize = fontSize - 10;
            break;
          case 19:
            fontSize = fontSize - 11;
            break;
          case 20:
            fontSize = fontSize - 12;
            break;
        }
        if (this.serviceProviderName.length > 20) {
          fontSize = fontSize - 15;
        }
      }

      return `width:100%;position:absolute;top:${top}px;font-size:${fontSize}px;z-index:100;text-align:center;font-weight:bold`;
    },
    merchantIdStyle() {
      let top = 0;
      if (this.payType === 2) {
        top = 535.5 * (this.screenWidth / 375);
      } else {
        top = 463.5 * (this.screenWidth / 375);
      }
      const fontSize = 17 * (this.screenWidth / 375);
      return `position:absolute;top:${top}px;font-size:${fontSize}px;text-align:center;width:100%;font-weight:bold`;
    },
    detailTextStyle() {
      let top = 0;
      let left = 0;
      if (this.payType === 2) {
        top = 580 * (this.screenWidth / 375);
      } else {
        top = 510 * (this.screenWidth / 375);
      }
      const textWidth = this.div1BgImgW * (this.screenWidth / 375);
      left = 21 * (this.screenWidth / 375);
      return `width:${textWidth}px;position:absolute;top:${top}px;left:${left}px;font-size:12px;margin:0 auto;color:#646464`;
    },
    buttonStyle() {
      const bgWidth = this.div1BgImgW * (this.screenWidth / 375);
      const top = 585.5 * (this.screenWidth / 375);
      const left = 20 * (this.screenWidth / 375);
      return `height:45px;width:${bgWidth}px;position:absolute;top:${top}px;left:${left}px;text-align:center;line-height:45px;color:#fff;border-radius: 7px;`;
    },
  },
  methods: {
    // 通过接口获取微信二维码
    getWeChatMerchantMsg(customerId) {
      CusLoadingOpen();
      GetWeChatMerchantMsg({ customerId })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusLoadingClose();
              if (res.data.status === 2) {
                this.qrCode = 'data:image/png;base64,' + res.data.weChatImg;
                this.wechatMerchantId = res.data.wechatMerchantId;
                this.serviceProviderName = res.data.serviceProviderName;
                this.hasQrCode = 1;
              } else {
                this.qrCode = require('@/assets/qrcode-no-img.png');
                this.errorMsg = res.data.errorMsg;
                CusToast(res.data.errorMsg);
              }
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
              this.qrCode = require('@/assets/qrcode-no-img.png');
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取支付宝二维码，2022.8.12
    getAliPayMerchantMsg(customerId) {
      CusLoadingOpen();
      GetAliPayMerchantMsg({ customerId })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusLoadingClose();
              if (res.data.status === 2) {
                this.qrCode = res.data.aliPayImg;
                this.wechatMerchantId = res.data.wechatMerchantId;
                this.serviceProviderName = res.data.serviceProviderName;
                this.hasQrCode = 1;
                if (res.data.aliPayImgType === 2) {
                  this.serviceProviderNameShow = true;
                  this.noImg = res.data.aliPayImg;
                } else {
                  this.div2BgImgPath = res.data.aliPayImg;
                }
              } else {
                CusToast(res.data.errorMsg);
                this.noImg = require('@/assets/qrcode-no-img.png');
              }
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
              this.noImg = require('@/assets/qrcode-no-img.png');
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 返回事件
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 文字拷贝成功事件
    onWordCopySuccess() {
      CusToast('复制商户号成功');
    },
    // 文字拷贝失败事件
    onWordCopyError() {
      CusToast('复制商户号失败');
    },
  },
};
</script>
